export default __webpack_public_path__ + "static/media/image6.2f95ed58.png";